import React from 'react';
import { Header, Button } from 'semantic-ui-react';
import Modal from '@/components/Modal';

import { format, isAfter, isOpenEndedDate, toDate } from '@/utils/datetime';
import useTranslate from '@/hooks/useTranslate';

interface Props {
    periodEndDate?: string | null;
    onConfirm: () => void;
    onCancel: () => void;
}

const DowngradeLicenseModal: React.FC<Props> = ({ periodEndDate, onConfirm, onCancel }) => {
    const { translate } = useTranslate();

    const hasDate =
        !!periodEndDate && !isOpenEndedDate(periodEndDate) && isAfter(toDate(periodEndDate), new Date());

    return (
        <Modal open size="mini" style={{ textAlign: 'center' }} closeIcon onClose={onCancel}>
            <Modal.Header>
                <Header size="medium" content={translate('licenses.downgrade.title')} icon="attention" />
            </Modal.Header>
            <Modal.Content>
                {hasDate
                    ? translate('licenses.downgrade.textWithDate', {
                          date: format(periodEndDate as string, 'PPP'),
                      })
                    : translate('licenses.downgrade.textNoDate')}
            </Modal.Content>
            <Modal.Actions style={{ textAlign: 'center' }}>
                <Button
                    basic
                    primary
                    content={translate('licenses.cancelButton')}
                    onClick={onCancel}
                />
                <Button
                    primary
                    data-testid="downgrade-continue"
                    content={translate('licenses.downgrade.continue')}
                    onClick={onConfirm}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default DowngradeLicenseModal;
